import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=8284e0fc"
import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8284e0fc')) {
      api.createRecord('8284e0fc', component.options)
    } else {
      api.reload('8284e0fc', component.options)
    }
    module.hot.accept("./DashboardPage.vue?vue&type=template&id=8284e0fc", function () {
      api.rerender('8284e0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/dashboard/DashboardPage.vue"
export default component.exports